import { render, staticRenderFns } from "./ckConfigItem.vue?vue&type=template&id=c47d84d4&"
import script from "./ckConfigItem.vue?vue&type=script&lang=js&"
export * from "./ckConfigItem.vue?vue&type=script&lang=js&"
import style0 from "./ckConfigItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports